<template>
  <el-dialog class="model-solution" v-model="modelSolutionState.open" title="">
    <div class="model-solution-img">
      <img src="@/assets/images/modelSolution_img.png" />
    </div>
    <div class="model-solution-content">
      <div class="title">获取解决方案</div>
      <div class="desc">完善您的信息，方便我们为您提供更优质的方案</div>
      <el-form
        :model="form"
        label-width="auto"
        ref="ruleFormRef"
        :rules="rules"
        label-position="left"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="手机号" prop="number">
          <el-input v-model="form.number" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="公司名称" prop="enterpriseName">
          <el-input
            v-model="form.enterpriseName"
            placeholder="请输入公司名称"
          />
        </el-form-item>
        <el-form-item label="需求" prop="requirement">
          <el-input
            v-model="form.requirement"
            type="textarea"
            placeholder="请输入需求"
          />
        </el-form-item>
        <el-button
          class="submit-btn"
          type="primary"
          @click="submitForm(ruleFormRef)"
          >立即获取</el-button
        >
      </el-form>
    </div>
  </el-dialog>
</template>
<script lang="ts" setup name="ModelSolution">
import { ref, reactive, onMounted } from "vue";
import type { FormInstance, FormRules } from "element-plus";
import EventBus from "@/utils/eventBus";
import { postSolutionApi } from "@/api/module/solution";
import { onUnmounted } from "vue";
export interface ComfigExposed {
  open: typeof open,
  close: typeof close
}
const props = withDefaults(defineProps<{open?: boolean;}>(),{
  open: false,
});
interface RuleForm {
  name: string;
  number: string;
  enterpriseName: string;
  requirement: string;
}
const ruleFormRef = ref<FormInstance>();
const form = reactive<RuleForm>({
  name: "",
  number: "",
  enterpriseName: "",
  requirement: "",
});
const modelSolutionState = reactive({
	open: false,
	params: null
})
const rules = reactive<FormRules<RuleForm>>({
  name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
  number: [
    { required: true, message: "请输入手机号", trigger: "blur" },
    {
      pattern: /^1[3-9]\d{9}$/,
      message: "请输入正确的手机号格式",
      trigger: "blur",
    },
  ],
  enterpriseName: [
    { required: true, message: "请输入公司名称", trigger: "blur" },
  ],
});
const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      
      postSolutionApi(form).then((res) => {
        if (res.code === 200) {
					handleOk();
          EventBus.$emit("modelSolutionSuccess", true);
          modelSolutionState.open = false;
        }
      });
    } else {
      console.log("error submit!", fields);
    }
  });
};
const open = (params: any) => {
	form.name = "";
	form.number = "";
	form.enterpriseName = "";
	form.requirement = "";
	modelSolutionState.open = true;
	modelSolutionState.params = params;
}

const handleOk=()=>{
	modelSolutionState.open = false;
	if(modelSolutionState.params?.ok)modelSolutionState.params.ok();	
}
const handleCancel=()=>{
	modelSolutionState.open = false;
	if(modelSolutionState.params?.cancel)modelSolutionState.params?.cancel();
}
onMounted(() => {
  EventBus.$on("modelSolutionOpen", async function (data?: boolean = true) {
		form.name = "";
		form.number = "";
		form.enterpriseName = "";
		form.requirement = "";
    modelSolutionState.open = data;
  });
});
onUnmounted(()=>{
	EventBus.$off("modelSolutionSuccess");
})
defineExpose<ComfigExposed>({open:open, ok:handleOk, cancel:handleCancel})
</script>
<style lang="scss">
body {
  .model-solution {
    padding: 0;
    border-radius: 20px;
    width: 1050px;
    .el-dialog__header {
      height: 0;
      font-size: 0;
      line-height: 0;
      padding: 0;
      .el-dialog__headerbtn {
        position: absolute;
        background-color: #fff;
        right: -20px;
        top: -20px;
        width: 40px;
        height: 40px;
        line-height: 40px;
        border-radius: 50%;
        font-size: 24px;
        padding: 0;
        i {
          display: block;
          margin: auto;
        }
      }
    }
    .el-dialog__body {
      display: flex;
      .model-solution-img {
        width: 45%;
        display: block;
        border-radius: 20px 0 0 20px;
        overflow: hidden;
        img {
          width: 100%;
          max-width: 100%;
          display: block;
        }
      }
      .model-solution-content {
        flex: 1;
        padding: 50px;
        .title {
          text-align: center;
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 10px;
        }
        .desc {
          font-size: 16px;
          text-align: center;
          margin-bottom: 30px;
        }
        .el-form-item {
          margin-bottom: 20px;
        }
        .el-form-item__error {
          font-size: 14px;
        }
        .el-form-item__label {
          line-height: 50px;
          font-size: 14px;
          height: 50px;
        }
        .el-form-item__label-wrap {
          padding-right: 10px;
        }
        .el-input__inner {
          padding: 10px 10px;
          height: 50px;
          font-size: 14px;
        }
        .el-textarea__inner {
          padding: 10px 15px;
          height: 80px;
          font-size: 14px;
        }
        .submit-btn {
          height: 60px;
          background-color: #0055d9;
          display: block;
          width: 100%;
          border: 0;
          border-radius: 10px;
          margin-top: 30px;
          font-size: 20px;
        }
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  body {
    .model-solution {
      width: 80vw;
      .el-dialog__header {
        .el-dialog__headerbtn {
          width: 60px;
          height: 60px;
          line-height: 60px;
          font-size: 40px;
        }
      }
      .el-dialog__body {
        .model-solution-img {
          display: none;
        }
        .model-solution-content {
          .title {
            font-size: 48px;
          }
          .desc {
            font-size: 30px;
            margin-bottom: 60px;
          }
          .el-form-item {
            margin-bottom: 50px;
          }
          .el-form-item__error {
            font-size: 28px;
          }
          .el-form-item__label {
            display: none;
            line-height: 90px;
            height: 90px;
            font-size: 28px;
          }
          .el-form-item__label-wrap {
            padding-right: 10px;
            font-size: 28px;
          }
          .el-input__inner {
            padding: 10px 10px;
            height: 90px;
            font-size: 28px;
          }
          .el-textarea__inner {
            padding: 20px 40px;
            height: 160px;
            font-size: 28px;
          }
          .submit-btn {
            height: 110px;
            font-size: 36px;
            margin-top: 60px;
          }
        }
      }
    }
  }
}
</style>
